import React, { Component } from 'react';
import { Label } from 'reactstrap';
import _ from 'lodash';
import { DatePicker, DatetimePicker } from '../../../commons/controls.js';
import { ProgressButton } from '../../../commons/ProgressButton';
import BootstrapTable from 'react-bootstrap-table-next';
import { PaginationTotal } from '../../../commons/controls';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import Service from '../services.js';
import Loader from '../../../commons/loader';
import NetworkEmptyState from '../../../commons/networkemptystate';
import QueryEmptyState from '../../../commons/queryempty';
import DataEmptyState from '../../../commons/dataemptystate';
import FileSaver from 'file-saver';
import 'moment/locale/hu';
import moment from 'moment';
import Excel from 'exceljs';
import NumberFormatter from '../../../commons/NumberFormatter.js';
import RFForm from '../../../components/Form/RFForm.js';
import CustomTooltip from '../../../components/Tooltip/CustomTooltip';
import getTooltip from '../BufeTooltips';
import SelectField from '../../../components/Form/SelectField.js';
import TimeFormatter from '../../../commons/TimeFormatter.js';
import RFField from '../../../components/Form/RFField.js';
import Lib from '../../../commons/lib.js';

class EladasiLista extends Component {

  constructor(props) {
    super(props);
    this.state = {
      listLoadingButton: false,
      tableStatus: 'QUERY', // [LOAD', NETW', 'LIST', 'QUERY', DATA]

      // FILTER VALUES
      kezdete: null,
      vege: null,
      filterBufe: null,
      filterTermek: null,
      filterTermekcsoport: null,
      bufek: []
    };
  }

  componentDidMount() {
    this.getBufek();
    this.selected = false;
  }

  checkKotelezoMezok = () => {
    if (!this.state.kezdete) {
      this.props.globals.addError("A kezdete mező kitöltése kötelező!");
    } else if (!this.state.vege) {
      this.props.globals.addError("A vége mező kitöltése kötelező!");
    } else if (this.state.kezdete > this.state.vege) {
      this.props.globals.addError("Az időszak kezdete nem lehet nagyobb az időszak végénél!");
    } else
      return true;
  }

  updateTable = () => {
    const {
      kezdete,
      vege,
      filterBufe: filterBufe,
      filterTermekcsoport: filterTermekcsoport,
      filterTermek: filterTermek,
    } = this.state;

    if (this.checkKotelezoMezok()) {
      let filters = {};
      filters.kezdete = kezdete ? TimeFormatter.formatIsoZ(kezdete) : undefined;
      filters.vege = vege ? TimeFormatter.formatIsoZ(vege) : undefined;
      filters.bufeid = filterBufe || undefined;
      if (filterTermekcsoport) {
        filters.termekcsoportazon = filterTermekcsoport.azonosito;
        filters.termekcsoportnev = filterTermekcsoport.nev;
      }
      if (filterTermek) {
        filters.termekazon = filterTermek.azonosito;
        filters.termeknev = filterTermek.rovidnev;
      }
      this.setState({ listLoadingButton: true, tableStatus: 'LOAD' }, () => {
        Service.listEladasok(filters, (err, res) => {
          if (!err) {
            let eladasok = res[0];
            this.setState({
              eladasokJson: eladasok,
              listLoadingButton: false,
              tableStatus: eladasok && eladasok.length > 0 ? 'LIST' : 'DATA',
            });
          } else {
            this.setState({
              listLoadingButton: false,
              tableStatus: err && err.responseJSON && err.responseJSON.hibaazon == "EMPTY_FILTERS" ? 'QUERY' : 'NETW',
            });
          }
        });
      });
    }
  }

  handleDateInputChange = (e, v, name) => {
    const value = v === '' ? null : v;
    this.setState({
      [name]: value
    });
  }

  handleDateChange = (e,v,type) => {
    if(this.selected) {
      this.selected = false;
      
      switch (type) {
        case 'FORMIDOSZAKKEZDETE':
          this.setState({ kezdete: (moment(e).startOf('day')) });
          break;
        case 'FORMIDOSZAKVEGE':
          this.setState({ vege: (moment(e).endOf('day')) });
          break;
        default:
          break;
      }
    } else {
      switch (type) {
        case 'FORMIDOSZAKKEZDETE':
          this.setState({ kezdete: (v === '' ? null : e) });
          break;
        case 'FORMIDOSZAKVEGE':
          this.setState({ vege: (v === '' ? null : e) });
          break;
        default:
          break;
      }
    }
  }
  

  handleUpdateTermekcsoportInput = (value, { action }) => {
    switch (action) {
      case 'input-change':
        this.setState({ termekcsoportLoading: true }, () => {
          Service.searchTermekcsoport(value, (err, res) => {
            if (!err) {
              this.setState({ termekcsoportJson: res[0] });
            }
            this.setState({ termekcsoportLoading: false });
          });
        });
        break;
      default:
    }
  }

  handleUpdateTermekInput = (value, { action }) => {
    switch (action) {
      case 'input-change':
        this.setState({ termekLoading: true }, () => {
          Service.searchTermek(value, (err, res) => {
            if (!err) {
              this.setState({ termekJson: res[0] });
            }
            this.setState({ termekLoading: false });
          });
        });
        break;
      default:
    }
  }

  handleUpdateBufeInput = (value, { action }) => {
    switch (action) {
      case 'input-change':
        this.setState({ bufeLoading: true }, () => {
          Service.searchBufe(value, (err, res) => {
            if (!err) {
              this.setState({ bufeJson: res[0] });
            }
            this.setState({ bufeLoading: false });
          });
        });
        break;
      default:
    }
  }

  getBufek = () => {
    Service.listBufek((err, res) => {
      if (!err) {
        res[0].forEach((item) => {
          if (item.allapot) item.aktiv = item.allapot.name === 'AKTIV' ? 1 : 0;
        });
        this.setState({
          bufek: res[0]
        });
        this.setState({ filterBufe: res[0][0].id });
      }
    });
  }

  renderFilters = () => {
    const {
      kezdete: kezdete,
      vege: vege,
      filterTermekcsoport: filterTermekcsoport,
      filterTermek: filterTermek,
      filterBufe: filterBufe,
    } = this.state;
    return (
      <React.Fragment>
        <RFForm onSubmit={() => {}}>
          <div className="row">
            <div className="col-md-3">
              <DatetimePicker
                label="Időszak kezdete: *"
                name="idoszakkezdete"
                timePrecision="seconds"
                // value={kezdete}
                value={kezdete && new Date(kezdete)}
                //onChange={(e, v) => this.handleDateInputChange(e, v, "kezdete")}
                onChange={(e,v) => {this.handleDateChange(e,v,'FORMIDOSZAKKEZDETE')}} 
                onSelect={(e,v) => { this.selected = true }}
              />
            </div>
            <div className="col-md-3">
              <DatetimePicker
                label="Időszak vége: *"
                name="idoszakvege"
                timePrecision="seconds"
                // value={vege}
                value={vege && new Date(vege)}
                //onChange={(e, v) => this.handleDateInputChange(e, v, "vege")}
                onChange={(e,v) => {this.handleDateChange(e,v,'FORMIDOSZAKVEGE')}}
                onSelect={(e,v) => { this.selected = true }}
              />
            </div>

          </div>
          <div className="row" style={{ marginTop: 4 }}>
          <div className="col-md-3">
              <RFField
                type="select"
                name="filterBufe"
                id="filterBufe"
                label="Büfé:"
                value={filterBufe}
                onChange={e => this.setState({ filterBufe: e.target.value })}
                defaultSelect={<option value="" >Válassz büfét...</option>}
                selectOptions={this.state.bufek.map(e => <option key={e.id} value={e.id}>{e.nev + ' (' + e.kod + ')'}</option>)}
              />
            </div>
            <div className="col-md-3" >
              <SelectField
                label='Termékcsoport:'
                name="filterTermekcsoport"
                id="filterTermekcsoport"
                placeholder="Kezdj el gépelni a kereséshez..."
                noOptionsMessage={() => "Nincs keresési eredmény"}
                searchPromptText="Kezdj el gépelni a kereséshez..."
                loadingMessage={() => "Keresés..."}
                onChange={v => this.setState({ filterTermekcsoport: v })}
                onInputChange={_.debounce(this.handleUpdateTermekcsoportInput, 1000)}
                options={this.state.termekcsoportJson}
                value={filterTermekcsoport}
                isClearable
                isLoading={this.state.termekcsoportLoading}
                getOptionValue={option => option.nev + option.azonosito}
                getOptionLabel={option => option.nev + ' (' + option.azonosito + ')'}
              />
            </div>
            <div className="col-md-3" >
              <SelectField
                label='Termék:'
                name="filterTermek"
                id="filterTermek"
                placeholder="Kezdj el gépelni a kereséshez..."
                noOptionsMessage={() => "Nincs keresési eredmény"}
                searchPromptText="Kezdj el gépelni a kereséshez..."
                loadingMessage={() => "Keresés..."}
                onChange={v => this.setState({ filterTermek: v })}
                onInputChange={_.debounce(this.handleUpdateTermekInput, 1000)}
                options={this.state.termekJson}
                value={filterTermek}
                isClearable
                isLoading={this.state.termekLoading}
                getOptionValue={option => option.rovidnev + option.azonosito}
                getOptionLabel={option => option.rovidnev + ' (' + option.azonosito + ')'}
              />
            </div>
            <div className="col-md-2" style={{ paddingTop: "28px" }}>
              <ProgressButton color="primary" id="save" loading={this.state.listLoadingButton} onClick={e => this.updateTable(e)} >Keresés</ProgressButton>{' '}
            </div>
          </div>
        </RFForm>
      </React.Fragment>
    )
  }

  renderXlsxButton = () => {
    return <button
      type="button"
      className="btn btn-success"
      style={{ marginBottom: 10 }}
      onClick={() => {
        const datas = JSON.parse(JSON.stringify(this.state.eladasokJson));

        let xlsDatas = [];
        datas.forEach((element) => {

          xlsDatas.push([
            element.bufeNev, element.termekcsoportNev, element.termekcsoportKod, element.termekNev, element.termekKod, element.mennyiseg
          ]);
        });

        let kezdeteFormated = TimeFormatter.formatDateNoDots(this.state.kezdete);
        let vegeFormated = TimeFormatter.formatDateNoDots(this.state.vege);

        const wb = new Excel.Workbook();
        const ws = wb.addWorksheet(kezdeteFormated + '-' + vegeFormated);

        ws.columns = [
          { key: 'bufeNev', width: 35 },
          { key: 'termekcsoportNev', width: 35 },
          { key: 'termekcsoportKod', width: 35 },
          { key: 'termekNev', width: 35 },
          { key: 'termekKod', width: 35 },
          { key: 'mennyiseg', width: 35, style: { alignment: { horizontal: 'right'}}},
        ];

        ws.addTable({
          name: 'Táblázat',
          ref: 'A1',
          headerRow: true,
          style: {
            theme: 'TableStyleLight1',
            showRowStripes: true,
          },
          columns: [
            { name: 'Büfé', filterButton: true },
            { name: 'Termékcsoport neve', filterButton: true },
            { name: 'Termékcsoport kódja', filterButton: true },
            { name: 'Termék neve', filterButton: true },
            { name: 'Termék kódja', filterButton: true },
            { name: 'Összesített mennyiség', filterButton: true },
          ],
          rows: xlsDatas,
        });
        ws.getRow(1).alignment = 'left';
        if (datas.length > 0) {
          let kezdeteFormated = TimeFormatter.formatDateNoDots(this.state.kezdete);
          let vegeFormated = TimeFormatter.formatDateNoDots(this.state.vege);
          wb.xlsx.writeBuffer()
            .then(buffer => FileSaver.saveAs(new Blob([buffer]), 'bufe_eladasi_lista_' + kezdeteFormated + '-' + vegeFormated + '.xlsx'))
            .catch();
        }
      }
      }
    >
  Export xlsx
    </button >
  }

renderTable = () => {
  const options = {
    sizePerPage: 50,
    showTotal: true,
    paginationTotalRenderer: PaginationTotal,
    sizePerPageList: [
      { text: '25', value: 25 },
      { text: '50', value: 50 },
      { text: '100', value: 100 }
    ],
  };

  const columns = [
    {
      dataField: 'bufeNev',
      text: 'Büfé',
      filter: textFilter({
        delay: 400,
        placeholder: 'Keresés...',
      }),
      style: {
        whiteSpace: 'pre-line'
      },
      sort: true
    },
    {
      dataField: 'termekcsoportNev',
      text: 'Termékcsoport neve',
      filter: textFilter({
        delay: 400,
        placeholder: 'Keresés...',
      }),
      style: {
        whiteSpace: 'pre-line'
      },
      sort: true
    },
    {
      dataField: 'termekcsoportKod',
      text: 'Termékcsoport kódja',
      style: {
        whiteSpace: 'pre-line'
      },
    },
    {
      dataField: 'termekNev',
      text: 'Termék neve',
      filter: textFilter({
        delay: 400,
        placeholder: 'Keresés...',
      }),
      style: {
        whiteSpace: 'pre-line'
      },
      sort: true,
    },
    {
      dataField: 'termekKod',
      text: 'Termék kódja',
      style: {
        whiteSpace: 'pre-line'
      },
    },
    {
      dataField: 'mennyiseg',
      text: 'Összesített mennyiség',
      style: NumberFormatter.styleTextAlignWhiteSpace,
      formatter: NumberFormatter.formatterSpaceOsszeg,
    },
  ];

  return (
    <div>
      {this.state.eladasokJson && this.state.eladasokJson.length > 0 ? this.renderXlsxButton() : <div />}
      <div className="animated fadeIn">
        <BootstrapTable
          bootstrap4
          keyField="id"
          data={this.state.eladasokJson}
          columns={columns}
          filter={filterFactory()}
          pagination={paginationFactory(Lib.bootstraptableProps)}
          noDataIndication="Nincs megjelenítendő adat!"
        />
      </div>
    </div>
  );
}

render() {
  let cardStyle = {
    padding: 10
  };
  return (
    <div>
    <div className="animated fadeIn">
      <div className="card">
        <div className="card-header">
          Eladási lista
          <CustomTooltip text={getTooltip('eladasilista')} id="eladasilistaTT" />
          {/* <YouTube data={videoData} /> */}
        </div>
        <div style={cardStyle}>
          <div className="col-md-12">
      {this.renderFilters()}
      {this.state.tableStatus === 'LOAD' ? <Loader /> : <span />}
      {this.state.tableStatus === 'QUERY' ? <QueryEmptyState hasImage /> : <span />}
      {this.state.tableStatus === 'DATA' ? <DataEmptyState hasImage subtitle="Próbálj más előszűrést vagy vigyél fel új adatokat!" /> : <span />}
      <div style={{ paddingTop: '20px' }}>
        {this.state.tableStatus === 'LIST' ? this.renderTable() : <span />}
        {this.state.tableStatus === 'NETW' ? (
          <NetworkEmptyState
            hasImage
            submitClick={() => this.updateTable()}
          />) : <span />}
      </div>
    </div>
    </div>
    </div>
    </div>
    </div>
  );
}
}

export default EladasiLista;
